import HStack from 'components/atoms/stack/HStack';
import VStack from 'components/atoms/stack/VStack';
import { View, StyleSheet, Pressable } from 'react-native';
import { ThemedShared } from 'styles/themed';
import Text from 'theme/Text';

const ListItem = ({ title, description, accessoryRight, accessoryLeft, style, onPress, children }) => {

    return (
        <Pressable 
            onPress={onPress}>
            
            <View 
                style={ styles.container }>

                { children ?? (
                    <ListItemContent 
                        title={ title } 
                        description={ description } 
                        accessoryLeft={ accessoryLeft } 
                        accessoryRight={ accessoryRight } 
                    /> 
                )}
            </View>
        </Pressable>
    );
}

export const ListItemContent = ({ title, description, accessoryLeft, accessoryRight }) => {

    return (
        <HStack
            alignItems="center"
            style={styles.hStackJustifyContentFlexStart}>

            { accessoryLeft && (
                <View
                    style={ styles.itemContentLeft }>

                    { accessoryLeft }
                </View>
            ) }

            <VStack
                flex={1}>
                    
                <Text>{ title }</Text>

                { description && <Text>{ description }</Text> }
            </VStack>

            { accessoryRight && (
                <View
                    style={ styles.itemContentRight }>

                    { accessoryRight }
                </View>
            )}
        </HStack>
    )
}

const styles = StyleSheet.create({
	hStackJustifyContentFlexStart: {
		justifyContent: 'flex-start',
	},
    container: {
        flex: 1,
        padding: ThemedShared.paddingSmall.padding,
        backgroundColor: '#fff',
    },

    itemContentLeft: {
        flex: undefined,
        width: 'auto',
        paddingRight: ThemedShared.paddingSmall.padding,
        // backgroundColor: 'blue'
    },
    itemContentRight: {
        flex: undefined,
        width: 'auto',
        paddingLeft: ThemedShared.paddingSmall.padding,
    }
});

export default ListItem;
